import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { LanguageContext } from "context";
import { supabase } from "lib/supabaseClient";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext) as any;  
  const [isMobileRedirected, setIsMobileRedirected] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    const search = window.location.search;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      console.log("スマートフォンを検知しました。アプリを起動します...");
      const deepLinkUrl = `chronospark://auth/callback${search}${hash}`;
      window.location.href = deepLinkUrl;
      setIsMobileRedirected(true);
      return;
    }

    console.log("PCブラウザを検知しました。Webアプリで認証を継続します...");
    
    const params = new URLSearchParams(search.substring(1) + hash.substring(1));
    const type = params.get('type');
    const errorDescription = params.get('error_description');
    
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (errorDescription) {
      navigate("/pages/auth/Sign-In", { replace: true });
      return;
    }

    const processAuth = async () => {
      if (accessToken && refreshToken) {
        await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });
      }

      if (type === 'recovery') {
        navigate("/update-password", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  if (isMobileRedirected) {
    return (
      <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh" px={3} textAlign="center">
        <MDTypography variant="body2" color="text" mb={4}>
          {t("Common.start-message1")}
        </MDTypography>
        <MDButton 
          variant="gradient" 
          color="info" 
          onClick={() => navigate("/pages/auth/Sign-In", { replace: true })}
        >
          {t("Common.start-message2")}
        </MDButton>
      </MDBox>
    );
  }

  // 通常のローディング画面
  return (
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress color="info" />
      <MDTypography variant="h6" mt={2}>
        {t("Common.checking")}
      </MDTypography>
    </MDBox>
  );
}